import { AuthenticationResult } from "@azure/msal-browser";
import { getQusToken, setOptionHeaders } from "../auth/getAccessToken";

export class ClientBaseQus {
  protected async transformOptions(options: RequestInit): Promise<RequestInit> {
    let token: AuthenticationResult = await getQusToken();
    setOptionHeaders(options, token.accessToken);

    return Promise.resolve(options);
  }
}
